module.exports = __webpack_public_path__ + "img/minimum_order_delivery.d7c2bc7b.svg";